<script lang="ts">
  import { _ } from 'svelte-i18n';
  import StatusMark from './StatusMark.svelte';
  import { num } from './format';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // The Event Readiness of a race against its target, with the days to recover for each of Low, High and Peak.
  export let readiness: any;
</script>


<h3 class="text-sm font-medium mt-4 mb-1 text-zinc-600">{$_('report.readiness.heading')}</h3>
<table class="w-full text-sm">
  <thead>
    <tr class="text-left text-zinc-500">
      <th class="font-normal py-1">{$_('report.table.measure')}</th>
      <th class="font-normal py-1 text-right">{$_('report.table.target')}</th>
      <th class="font-normal py-1 pl-8 text-right">{$_('report.readiness.result')}</th>
      <th class="w-8" />
    </tr>
  </thead>
  <tbody>
    <tr class="border-t">
      <td class="py-1.5">{$_('report.readiness.name')}</td>
      <td class="py-1.5 text-right tabular-nums whitespace-nowrap">{readiness.target !== null ? `${num(readiness.target, 1)} ${readiness.target_tag}` : '–'}</td>
      <td class="py-1.5 pl-8 text-right tabular-nums whitespace-nowrap">{num(readiness.level, 1)} {readiness.tag}</td>
      <td class="py-1.5 text-center"><StatusMark status={readiness.status} /></td>
    </tr>
  </tbody>
</table>
<p class="mt-1 text-xs text-zinc-500">{$_('report.readiness.by_load', { values: { low: num(readiness.parts.low, 1), high: num(readiness.parts.high, 1), peak: num(readiness.parts.peak, 1) } })}</p>
